import type React from "react";
import { SkillsContainer, SkillCategory, CategoryTitle, SkillList, Skill } from "./styles";

const Skills: React.FC = () => {
	return (
		<SkillsContainer>
			<SkillCategory>
				<CategoryTitle>Frontend Technologies</CategoryTitle>
				<SkillList>
					<Skill>React.js / Next.js</Skill>
					<Skill>React Native</Skill>
					<Skill>TypeScript / JavaScript</Skill>
					<Skill>HTML5 / CSS3 / SASS</Skill>
					<Skill>Tailwind CSS / Styled Components</Skill>
					<Skill>Three.js / WebGL</Skill>
				</SkillList>
			</SkillCategory>

			<SkillCategory>
				<CategoryTitle>Backend & Database</CategoryTitle>
				<SkillList>
					<Skill>Typescript / Node.js</Skill>
					<Skill>C# / .NET</Skill>
					<Skill>Python / Django </Skill>
					<Skill>C++</Skill>
					<Skill>PostgreSQL / MongoDB / Redis</Skill>
					<Skill>GraphQL / REST APIs</Skill>
				</SkillList>
			</SkillCategory>

			<SkillCategory>
				<CategoryTitle>Messaging & Streaming</CategoryTitle>
				<SkillList>
					<Skill>Kafka</Skill>
					<Skill>RabbitMQ</Skill>
					<Skill>Amazon SQS</Skill>
					<Skill>Amazon SNS</Skill>
				</SkillList>
			</SkillCategory>

			<SkillCategory>
				<CategoryTitle>Cloud & DevOps</CategoryTitle>
				<SkillList>
					<Skill>AWS / GCP / Digital Ocean</Skill>
					<Skill>Docker / Kubernetes</Skill>
					<Skill>CI/CD Pipelines</Skill>
					<Skill>Terraform</Skill>
				</SkillList>
			</SkillCategory>

			<SkillCategory>
				<CategoryTitle>Production Reliability</CategoryTitle>
				<Skill>Service health, SLIs & SLOs</Skill>
				<Skill>Metrics, logs & distributed tracing</Skill>
				<Skill>Grafana Stack & Datadog</Skill>
				<Skill>Alert design, incident triage & debugging</Skill>
			</SkillCategory>
		</SkillsContainer>
	);
};

export default Skills;
